import { useCallback, useState } from 'react';
import { Icon } from './Icon';
import { useUpdateReady } from '../hooks/useUpdateReady';
import { haptic } from '../lib/haptic';
import { playSfx } from '../lib/sfx';
import type { View } from '../types';
import './Dock.css';

type Props = {
  onOpen: (view: View) => void;
};

export function Dock({ onOpen }: Props) {
  const updateReady = useUpdateReady();
  const [updating, setUpdating] = useState(false);

  const open = useCallback((view: View) => {
    haptic('light');
    playSfx('tap');
    onOpen(view);
  }, [onOpen]);

  const handleUpdate = useCallback(async () => {
    haptic('medium');
    playSfx('tap');
    setUpdating(true);
    try {
      if ('caches' in window) {
        const keys = await caches.keys();
        await Promise.all(keys.map((k) => caches.delete(k)));
      }
      if ('serviceWorker' in navigator) {
        const reg = await navigator.serviceWorker.getRegistration();
        await reg?.update().catch(() => {});
      }
    } finally {
      window.location.reload();
    }
  }, []);

  return (
    <div className="home-dock" aria-label="Accesos rápidos">
      <button
        type="button"
        className="dock-item dock-item--gray tap"
        onClick={() => open({ name: 'admin' })}
        aria-label="Ajustes"
      >
        <Icon name="settings" />
      </button>

      <button
        type="button"
        className="dock-item dock-item--lime tap"
        onClick={() => open({ name: 'game', game: 'phone' })}
        aria-label="Teléfono"
      >
        <Icon name="phone" />
      </button>

      <button
        type="button"
        className="dock-item dock-item--spotilisa tap"
        onClick={() => open({ name: 'game', game: 'musica' })}
        aria-label="Spotilisa"
      >
        <Icon name="music" />
      </button>

      {/* El badge va FUERA del botón: .dock-item clipea con squircle y
          recortaba la burbuja — ver .dock-slot en Dock.css. */}
      <span className="dock-slot">
        <button
          type="button"
          className={`dock-item dock-item--accent tap${updating ? ' is-updating' : ''}`}
          onClick={handleUpdate}
          disabled={updating}
          aria-label={updateReady ? 'Actualizar (hay una versión nueva)' : 'Actualizar'}
        >
          <Icon name="refresh" />
        </button>
        {updateReady && <span className="dock-badge" aria-hidden="true" />}
      </span>
    </div>
  );
}
